// extracted by mini-css-extract-plugin
module.exports = {"tabTitle":"QrCustomization_tabTitle__WQTGD","Header":"QrCustomization_Header__YDO3d","step":"QrCustomization_step__J7bKq","TopTitle":"QrCustomization_TopTitle__kKUCr"};